// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"48":"320ae2af","447":"b0edb4d3","456":"374d4649"}[chunkId] + ".js";
};